var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.5,245.1l56.8-113.7c10.9-21.7,33-35.4,57.3-35.4h304.9c24.2,0,46.4,13.7,57.2,35.4l56.8,113.7 c3.6,7.2,5.5,15.1,5.5,23.2c0,27.3-21.2,49.7-48,51.6V512c0,17.7-14.3,32-32,32s-32-14.3-32-32V320h-96v176c0,26.5-21.5,48-48,48 H144c-26.5,0-48-21.5-48-48V319.9c-26.8-1.9-48-24.3-48-51.6C48,260.3,49.9,252.3,53.5,245.1z M160,320v112c0,8.8,7.2,16,16,16h128 c8.8,0,16-7.2,16-16V320H160z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopSolidFull);
export default __webpack_public_path__ + "static/media/shop-solid-full.a100964d236a362ad933df916bb19aa4.svg";
export { ForwardRef as ReactComponent };